import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import request from 'lib/request';
import type { BulkDumpStatusResponse } from './types';

const refreshCounterAtom = atom(0);

const bulkDumpStatusBaseAtom = atom(async (get) => {
  get(refreshCounterAtom);

  const response = await request.get<BulkDumpStatusResponse>(
    '/admin/bulk_dump_status'
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});

const bulkDumpStatusLoadableAtom = loadable(bulkDumpStatusBaseAtom);

export const bulkDumpStatusAtom = atom(
  (get) => get(bulkDumpStatusLoadableAtom),
  (_get, set) => {
    set(refreshCounterAtom, (c) => c + 1);
  }
);
